import React from "react";
import BrandingHeader from "../components/BrandingHeader";
import mentor from "../assets/images/mentor.png";
import member from "../assets/images/member.png";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
// import { db } from "../../src/firebase";

function GettingStarted() {
  const { currentUser } = useAuth();
  const history = useHistory();

  async function handleSubmit() {
    history.push("/mentor/verify-email");
    // e.preventDefault();

    // try {
    //   await db
    //     .collection("invitedMentors")
    //     .doc(currentUser.email)
    //     .get()
    //     .then((doc) => {
    //       if (doc.data()) {
    //         history.push("/mentor/verify-email");
    //       } else {
    //         history.push("/invitation");
    //       }
    //     });
    // } catch {
    //   setError("Something went wrong! Try after few minutes");
    // }
  }

  return currentUser ? (
    <div>
      <BrandingHeader />
      <div className="mx-auto sm:w-2/5 text-center">
        <h1 className="text-3xl p-4 sm:p-5 sm:text-3xl font-semibold mt-8 sm:mt-8">
          How do you want to get involved in this community?
        </h1>
      </div>
      <div class="flex flex-wrap items-center justify-center">
        <Link to="/member/verify-email">
          <div class="flex-shrink-0 m-6 relative overflow-hidden bg-gradient-to-r from-blue-500 to-blue-900  rounded-lg max-w-xs shadow-lg">
            <svg
              class="absolute bottom-0 left-0 mb-8"
              viewBox="0 0 375 283"
              fill="none"
              style={{ transform: "scale(1.5)", opacity: "0.1" }}
            >
              <rect
                x="159.52"
                y="175"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 159.52 175)"
                fill="white"
              />
              <rect
                y="107.48"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 0 107.48)"
                fill="white"
              />
            </svg>
            <div class="relative pt-10 px-10 flex items-center justify-center">
              <div
                class="block absolute w-48 h-48 bottom-0 left-0 -mb-24 ml-3"
                style={{
                  background: "radial-gradient(black, transparent 60%)",
                  transform: "rotate3d(0, 0, 1, 20deg) scale3d(1, 0.6, 1}",
                  opacity: "0.2",
                }}
              ></div>
              <img class="relative w-48 sm:w-40" src={member} alt="" />
            </div>
            <div class="relative text-white px-6 pb-6 mt-6 mx-auto">
              <div class="flex justify-center">
                <span class="block font-semibold text-xl">Community user</span>
              </div>
              <span class="block opacity-75 ">
                You'll be able to book mentors, write reviews and more.
              </span>
            </div>
          </div>
        </Link>
        <div
          onClick={handleSubmit}
          class="flex-shrink-0 m-6 relative overflow-hidden bg-gradient-to-r from-blue-500 to-blue-900  rounded-lg max-w-xs shadow-lg cursor-pointer"
        >
          <svg
            class="absolute bottom-0 left-0 mb-8"
            viewBox="0 0 375 283"
            fill="none"
            style={{ transform: "scale(1.5)", opacity: "0.1" }}
          >
            <rect
              x="159.52"
              y="175"
              width="152"
              height="152"
              rx="8"
              transform="rotate(-45 159.52 175)"
              fill="white"
            />
            <rect
              y="107.48"
              width="152"
              height="152"
              rx="8"
              transform="rotate(-45 0 107.48)"
              fill="white"
            />
          </svg>
          <div class="relative pt-10 px-10 flex items-center justify-center">
            <div
              class="block absolute w-48 h-48 bottom-0 left-0 -mb-24 ml-3"
              style={{
                background: "radial-gradient(black, transparent 60%)",
                transform: "rotate3d(0, 0, 1, 20deg) scale3d(1, 0.6, 1)",
                opacity: "0.2",
              }}
            ></div>
            <img class="relative w-48 sm:w-40" src={mentor} alt="" />
          </div>
          <div class="relative text-white px-6 pb-6 mt-6 mx-auto">
            <div class="flex justify-center">
              <span class="block font-semibold text-xl">Be a mentor</span>
            </div>
            <span class="block opacity-75">
              Meet the global community of devs, and meet new meentees.
            </span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Redirect to="/signup" />
  );
}

export default GettingStarted;
